import { render, staticRenderFns } from "./ticketActivities.vue?vue&type=template&id=bf20f550&scoped=true&"
import script from "./ticketActivities.vue?vue&type=script&lang=js&"
export * from "./ticketActivities.vue?vue&type=script&lang=js&"
import style0 from "./ticketActivities.vue?vue&type=style&index=0&id=bf20f550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf20f550",
  null
  
)

export default component.exports